import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import requests from 'app/requests/Engagement.requests'
import EngagementForm from '../EngagementForm'

const EngagementCreateForm = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <EngagementForm
            onSuccess={onSuccess}
            requestParam={requests.create()}
        />
    )
}

export default EngagementCreateForm
